module.exports = __webpack_public_path__ + "media/images/fer à repasser-b0f520937cd5cf5fc9b36526aa921c40.svg";